module.exports = __webpack_public_path__ + "static/media/layout6-img.1a8493f9.svg";